import { Navigate, useLocation } from 'react-router-dom';

/**
 * Default child of `/academy/:slug/book/:lessonId` redirects to `register`.
 * Must preserve query (e.g. `?invitation=`, `?studentInvite=`) and hash — plain `<Navigate to="register" />` drops them.
 */
export function PublicBookingIndexRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: 'register', search, hash }} replace />;
}
